import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Tabs, Tab, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useTranslation } from "react-i18next";

import PointEditor from "./components/PointEditor";
import BulkConstraintEditor from "./components/BulkConstraintEditor";
import AlertsEdit from "../Alerts/components/AlertsEdit";
import FacilityView from "./components/FacilityView";
import { ApiContext } from "../../App";


export default function Settings(props) {
	const {  facility } = props;
	
	const { t } = useTranslation();

	const [activeTab, setActiveTab] = React.useState("points");
	const [tariffs, setTariffs] = React.useState([]);
	const [controllers, setControllers] = React.useState([]);
	const [floorPlans, setFloorPlans] = React.useState([]);
	const [pointsData, setPointsData] = React.useState([]);

	const [pointDataHasChanged, setPointDataHasChanged] = React.useState(false);
	const [inputDataHasChanged, setInputDataHasChanged] = React.useState(false);
	const [latestUpdate, setLatestUpdate] = React.useState(new Date());

	const [alertOpen, setAlertOpen] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	const {pointsApi, tariffApi, controllerApi, floorPlanApi} = React.useContext(ApiContext)

	React.useEffect(() => {
		pointsApi.list(
			facility,
			(data) => {
				setPointsData(data);
			},
			() => {
				setAlertMessage(t("Couldn't connect to server."));
				setAlertOpen(true);
			}
		);

		tariffApi.list(
			facility,
			(data) => {
				setTariffs(data);
			},
			() => {
				setAlertMessage(t("Couldn't connect to server."));
				setAlertOpen(true);
			}
		);

		controllerApi.list(
			facility,
			(data) => {
				setControllers(data);
			},
			() => {
				setAlertMessage(t("Couldn't connect to server."));
				setAlertOpen(true);
			}
		);

		floorPlanApi.list(
			facility,
			(data) => {
				setFloorPlans(data);
			},
			() => {
				setAlertMessage(t("Couldn't connect to server."));
				setAlertOpen(true);
			}
		);
	}, [latestUpdate, facility]);

	const handleTabChange = (event, newValue) => {
		if ((newValue === "outputs" || newValue === "bulk") && pointDataHasChanged)
			setLatestUpdate(new Date());
		setPointDataHasChanged(false);

		if (newValue === "alerts" && inputDataHasChanged)
			setLatestUpdate(new Date());
		setInputDataHasChanged(false);

		setActiveTab(newValue);
	};

	return (
		<>
			<Stack>
				<Box
					sx={{
						borderBottom: 1,
						marginBottom: 0,
						borderColor: "divider",
					}}
				>
					<Tabs
						value={activeTab}
						onChange={handleTabChange}
					>
						<Tab
							label={t("Points")}
							value="points"
						/>
						<Tab
							label={t("Alerts")}
							value="alerts"
						/>
						<Tab
							label={t("Constraints")}
							value="bulk"
						/>
						<Tab
							label={t("Facility")}
							value="facility"
						/>
					</Tabs>
				</Box>
				<Box
					sx={{
						p: 3,
						height: "calc(100vh - 120px)",
						width: "100%",
						"& .actions": {
							color: "text.secondary",
						},
						"& .textPrimary": {
							color: "text.primary",
						},
					}}
				>
					{activeTab === "points" ? (
						<PointEditor
							points={pointsData}
							tariffs={tariffs}
							controllers={controllers}
							floorPlans={floorPlans}
							facility={facility}
							onChange={() => setPointDataHasChanged(true)}
						/>
					) : null}
					{activeTab === "bulk" ? (
						<BulkConstraintEditor
							points={pointsData}
							controllers={controllers}
							onChange={() => setPointDataHasChanged(true)}
							facility={facility}
						/>
					) : null}
					{activeTab === "alerts" ? (
						<AlertsEdit
							controllers={controllers}
							points={pointsData}
							facility={facility}
						/>
					) : null}
					{activeTab === "facility" && (
						<Box
							sx={{
								height: "calc(100vh - 120px)",
								width: "100%",
							}}
						>
							<FacilityView
								facility={facility}
								clientInfo={props.clientInfo}
							/>
						</Box>
					)}
				</Box>
			</Stack>
			<Dialog
				open={alertOpen}
				onClose={() => setAlertOpen(false)}
			>
				<DialogTitle id="alert-dialog-title">{t("Problem")}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{alertMessage}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setAlertOpen(false)}
						autoFocus
					>
						{t("OK")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
